<template>
  <v-layout align-center justify-center>
    <v-flex xs12 sm6 md4 lg3>
      <v-card >
        <v-toolbar dark color="primary">
          <v-toolbar-title>Handbook Acceptence</v-toolbar-title>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout class="pb-3" row wrap>
              <v-flex xs12>
                Please download and accept the Reno Rodeo Handbook. By entering your name and clicking accept, you agree to the Handbook.
              </v-flex>
              <v-flex xs12>
                <a href="https://front.rrride.com/api/documents/Volunteer%20Handbook.pdf" target="_blank">Download Handbook</a>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="name"
                  label="Name"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="acceptHandbook">Accept</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line=true
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'

export default {
  data: () => ({
    currentPage: 'Settings',
    userId: 0,
    name: '',
    snackbar: {
      show: false,
      color: '',
      message: ''
    }
  }),

  created () {
    this.$store.dispatch('setCurrentPage', this.currentPage)
    this.currentYear = this.$store.state.currentYear
    this.userId = this.$store.state.user.id
  },

  methods: {
    async acceptHandbook () {
      try {
        let member = {}

        member.name = this.name
        member.userId = this.userId

        const response = await Api().post('set_handbook', member)

        // console.log('res', response)
        this.$router.push({
          name: 'dashboard'
        })

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// src/components/Handbook.vue